// src/components/Page.js
import React from 'react';

/**
 * Page wrapper component for opt-in insets and container widths.
 * Provides consistent spacing and max-width constraints for content.
 * 
 * @param {Object} props
 * @param {'narrow'|'default'|'wide'|'fluid'} props.width - Container width preset
 * @param {boolean} props.inset - Whether to apply horizontal padding
 * @param {'auto'|'none'|'bottom'|'block'} props.safeArea - Safe area padding mode
 * @param {string} props.as - HTML element to render as
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Child content
 */
const Page = ({
  width = 'default',
  inset = true,
  safeArea = 'auto', // Default to bottom-only safe area
  as: Tag = 'div',
  className = '',
  children,
}) => {
  // Build container width class
  const widthClass = width === 'fluid' ? '' : `layout-container-${width}`;
  
  // Build padding class
  const paddingClass = inset ? 'layout-padding' : '';
  
  // Determine safe area class based on safeArea prop
  const safeAreaClass = 
    safeArea === 'none' ? '' :
    safeArea === 'block' ? 'safe-area-block' :
    'safe-area-bottom'; // 'auto' and 'bottom' both use bottom-only
  
  // Combine all classes
  const classes = [
    widthClass,
    paddingClass,
    safeAreaClass,
    'page', // Base vertical rhythm class
    className
  ].filter(Boolean).join(' ');

  return <Tag className={classes}>{children}</Tag>;
};

export default Page;